import { range } from 'lodash';
import React from 'react';
import Table from '@splunk/dashboard-visualizations/Table';

export default () => (
    <Table
        options={{
            headerTextColor: '#FF0000',
        }}
        encoding={{
            columns: ['primary.foo', 'primary.bar'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'foo' }, { name: 'bar' }],
                    columns: [range(5), range(5)],
                },
                meta: { totalCount: 100 },
            },
        }}
    />
);
